"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "agliano-terme": {
    "62c29893": [{
      "hkey": "ff7281b5",
      "slug": "agliano-terme",
      "name": "Agliano Terme",
      "primary": true,
      "skipSearch": false
    }],
    "73c7e720": [{
      "hkey": "ff7281b5",
      "slug": "agliano-terme",
      "name": "Agliano Terme",
      "primary": true,
      "skipSearch": false
    }],
    "8314abaa": [{
      "hkey": "ff7281b5",
      "slug": "agliano-terme",
      "name": "Agliano Terme",
      "primary": true,
      "skipSearch": false
    }],
    "99f5149b": [{
      "hkey": "ff7281b5",
      "slug": "agliano-terme",
      "name": "Agliano Terme",
      "primary": true,
      "skipSearch": false
    }],
    "9ea645c1": [{
      "hkey": "ff7281b5",
      "slug": "agliano-terme",
      "name": "Agliano Terme",
      "primary": true,
      "skipSearch": false
    }],
    "brusasacco": [{
      "hkey": "ff7281b5",
      "slug": "agliano-terme",
      "name": "Agliano Terme",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "d85dd3c3": [{
      "hkey": "ff7281b5",
      "slug": "agliano-terme",
      "name": "Agliano Terme",
      "primary": true,
      "skipSearch": false
    }],
    "fb796034": [{
      "hkey": "ff7281b5",
      "slug": "agliano-terme",
      "name": "Agliano Terme",
      "primary": true,
      "skipSearch": false
    }],
    "molizzo": [{
      "hkey": "ff7281b5",
      "slug": "agliano-terme",
      "name": "Agliano Terme",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "monsarinero": [{
      "hkey": "ff7281b5",
      "slug": "agliano-terme",
      "name": "Agliano Terme",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "paludo": [{
      "hkey": "ff7281b5",
      "slug": "agliano-terme",
      "name": "Agliano Terme",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "scorrone": [{
      "hkey": "ff7281b5",
      "slug": "agliano-terme",
      "name": "Agliano Terme",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "spessa": [{
      "hkey": "ff7281b5",
      "slug": "agliano-terme",
      "name": "Agliano Terme",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "strada-fornaci-stazione": [{
      "hkey": "ff7281b5",
      "slug": "agliano-terme",
      "name": "Agliano Terme",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "a410ccef": [{
      "hkey": "e6c2b09c",
      "slug": "salere-dani",
      "name": "Salere-Dani",
      "primary": true,
      "skipSearch": false
    }],
    "salere": [{
      "hkey": "e6c2b09c",
      "slug": "salere-dani",
      "name": "Salere-Dani",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;